export default "__VITE_ASSET__CyfrlstI__"